module.exports = __webpack_public_path__ + "static/img/login-bg.f16d441f.svg";